import { StartUpData } from "../api/mainApi";
import React from "react";

export const StartUpDataContext = React.createContext<StartUpData | undefined>(
	undefined
);

type StartUpDataProviderProps = {
	children: React.ReactNode;
	startUpData: StartUpData;
};

export function StartUpDataProvider({
										children,
										startUpData
									}: StartUpDataProviderProps) {
	return (
		<StartUpDataContext.Provider value={startUpData}>
			{children}
		</StartUpDataContext.Provider>
	);
}